<template>
  <div id="admisiion-ticket-type-list">
    <span v-if="ticket_type_status.name!=''" class="pg-admissionlist__ticket_list__list_title"> {{ ticket_type_status.name }}</span>
    <span>({{ticket_type_status.admitted}}／{{ticket_type_status.sum}}人)</span>
    <div class="mt5px"></div>
    <template v-if="is_giants_user">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr class="color-gray color-bg-white">
              <th class="pg-admissionlist__ticket_list__label__no-g">No.</th>
              <th class="pg-admissionlist__ticket_list__label__admisiion_status-g">受付状況</th>
              <th class="pg-admissionlist__ticket_list__label__admisiion_operation-g">受付操作</th>
              <th class="pg-admissionlist__ticket_list__label__name">招待者名 / 登録アカウント</th>
              <th class="pg-admissionlist__ticket_list__label__volume-g">枚数</th>
              <th v-for="(eq, index) in event_questionnaires" :key="eq.id" class="pg-admissionlist__ticket_list__label__introducer-g">
                {{ eq.introducer_text }}
              </th>
              <th class="pg-admissionlist__ticket_list__label__first_admission-g">初回受付日時</th>
              <th class="pg-admissionlist__ticket_list__label__note">備考</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(audience, index) in audiences">
              <tr>
                <td class="pg-admissionlist__ticket_list__label__no-g" v-html="index + 1"></td>
                <template v-if="!audience.admission">
                  <td class="pg-admissionlist__ticket_list__label__admisiion_status-g">-</td>
                  <td class="pg-admissionlist__ticket_list__label__admisiion_operation-g"><button v-if="audience.volume > 0" v-on:click="accept_admission(audience.admission_url)" class="pg-admissionlist__ticket_list__button__admission"> 受付する </button></td>
                </template>
                <template v-else>
                  <td class="pg-admissionlist__ticket_list__admitted_mark pg-admissionlist__ticket_list__label__admisiion_status-g">✔︎</td>
                  <td class="pg-admissionlist__ticket_list__label__admisiion_operation-g"><button v-if="audience.volume > 0" v-on:click="unaccept_admission(audience.admission_url)" class="pg-admissionlist__ticket_list__button__unadmission"> 受付済 </button></td>
                </template>
                <td class="pg-admissionlist__ticket_list__label__name">{{audience.name}} / {{audience.email}}</td>
                <td class="pg-admissionlist__ticket_list__label__volume-g">{{audience.volume}}</td>
                <td v-for="(eq, index) in event_questionnaires" :key="eq.id" class="pg-admissionlist__ticket_list__label__introducer-g">
                  {{ audience.event_questionnaire_answers.length > index ? audience.event_questionnaire_answers[index].introducer : '未回答'}}
                </td>
                <td class="pg-admissionlist__ticket_list__label__first_admission-g">{{audience.last_admission_at}}</td>
                <td class="pg-admissionlist__ticket_list__label__note">{{audience.note}}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>
    <template v-else>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr class="color-gray color-bg-white">
              <th class="pg-admissionlist__ticket_list__label__no">No.</th>
              <th class="pg-admissionlist__ticket_list__label__admisiion_status">受付状況</th>
              <th class="pg-admissionlist__ticket_list__label__admisiion_operation">受付操作</th>
              <th class="pg-admissionlist__ticket_list__label__name">名前 / メールアドレス</th>
              <th class="pg-admissionlist__ticket_list__label__volume">枚数</th>
              <th class="pg-admissionlist__ticket_list__label__first_admission">初回もぎり日時</th>
              <th v-for="(eq, index) in event_questionnaires" :key="eq.id" class="pg-admissionlist__ticket_list__label__introducer-g">
                {{ eq.introducer_text }}
              </th>
              <template v-if="use_introducer_tell">
                <th class="pg-admissionlist__ticket_list__label__introducer_add">電話番号</th>
              </template>
              <template v-if="use_introducer_adress">
                <th class="pg-admissionlist__ticket_list__label__introducer_add">住所</th>
              </template>
              <template v-if="use_introducer_name">
                <th class="pg-admissionlist__ticket_list__label__introducer_add">氏名</th>
              </template>
              <th class="pg-admissionlist__ticket_list__label__note">備考</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(audience, index) in audiences">
              <tr>
                <td class="pg-admissionlist__ticket_list__label__no" v-html="audience.receipt_no"></td>
                <template v-if="!audience.admission">
                  <td class="pg-admissionlist__ticket_list__label__admisiion_status">-</td>
                  <td class="pg-admissionlist__ticket_list__label__admisiion_operation"><button v-if="audience.volume > 0" v-on:click="accept_admission(audience.admission_url)" class="pg-admissionlist__ticket_list__button__admission"> もぎる </button></td>
                </template>
                <template v-else>
                  <td class="pg-admissionlist__ticket_list__admitted_mark pg-admissionlist__ticket_list__label__admisiion_status">✔︎</td>
                  <td class="pg-admissionlist__ticket_list__label__admisiion_operation"><button v-if="audience.volume > 0" v-on:click="unaccept_admission(audience.admission_url)" class="pg-admissionlist__ticket_list__button__unadmission"> もぎり解除 </button></td>
                </template>
                <td class="pg-admissionlist__ticket_list__label__name">{{audience.name}} / {{audience.email}}</td>
                <td class="pg-admissionlist__ticket_list__label__volume">{{audience.volume}}</td>
                <td class="pg-admissionlist__ticket_list__label__first_admission">{{audience.last_admission_at}}</td>
                <td v-for="(eq, index) in event_questionnaires" :key="eq.id" class="pg-admissionlist__ticket_list__label__introducer-g">
                  {{ audience.event_questionnaire_answers.length > index ? audience.event_questionnaire_answers[index].introducer : '未回答'}}
                </td>
                <template v-if="use_introducer_tell">
                  <td class="pg-admissionlist__ticket_list__label__introducer_add">{{audience.introducer_tell}}</td>
                </template>
                <template v-if="use_introducer_adress">
                  <td class="pg-admissionlist__ticket_list__label__introducer_add">{{audience.introducer_adress}}</td>
                </template>
                <template v-if="use_introducer_name">
                  <td class="pg-admissionlist__ticket_list__label__introducer_add">{{audience.introducer_name}}</td>
                </template>
                <td class="pg-admissionlist__ticket_list__label__note">{{audience.note}}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    ticket_type: { type: Object, required: true },
    program_id: { type: Number, required: true },
    admission_accept_path: { type: String, required: true },
    admission_unaccept_path: { type: String, required: true },
    can_action_cable: { type: Boolean, required: true },
    event_questionnaires: { type: Array, required: true },
    use_introducer_tell: { type: Boolean, required: true },
    use_introducer_name: { type: Boolean, required: true },
    use_introducer_adress: { type: Boolean, required: true },
    is_giants_user: { type: Boolean, required: true },
    is_assistant_page: { type: Boolean, required: true, default: false },
  },
  data() {
    return {
    }
  },
  created(){
    this.$store.commit('audience/pushTicketTypeStatus', this.ticket_type);
  },
  computed:{
    audiences: function() {
      return this.$store.getters['audience/getAudiencesByTid'](this.ticket_type.id);
    },
    ticket_type_status: function() {
      return this.$store.getters['audience/getTicketTypeStatusByTid'](this.ticket_type.id)
    },
  },
  methods: {
    // もぎり
    accept_admission(admission_url) {
      this.$store.dispatch('audience/accept_admission', {program_id: this.program_id, event_id: null, admission_url: admission_url, api_path: this.admission_accept_path, can_action_cable: this.can_action_cable})
    },
    // もぎり解除
    unaccept_admission(admission_url) {
      let assistantId = location.pathname.split('/admission/')[1];
      this.$store.dispatch('audience/unaccept_admission', {program_id: this.program_id, event_id: null, admission_url: admission_url, api_path: this.admission_unaccept_path, can_action_cable: this.can_action_cable, assistant_id: assistantId });
    }
  },
}
</script>


<style scoped>
  @import '../packs/application.css';

  .pg-admissionlist__ticket_list__label__no {
    width: 5%;
  }
  .pg-admissionlist__ticket_list__label__admisiion_status {
    width: 8%;
  }
  .pg-admissionlist__ticket_list__label__admisiion_operation {
    width: 10%;
  }
  .pg-admissionlist__ticket_list__label__name {
    width: 15%;
  }
  .pg-admissionlist__ticket_list__label__volume {
    width: 5%;
  }
  .pg-admissionlist__ticket_list__label__first_admission {
    width: 12%;
  }
  .pg-admissionlist__ticket_list__label__note {
    width: 10%;
  }
  .pg-admissionlist__ticket_list__label__introducer {
    width: 15%;
  }
  .pg-admissionlist__ticket_list__label__introducer_add {
    width: 7%;
  }
  .pg-admissionlist__ticket_list__button__admission {
    background-color: red;
    color: white;
    border-radius: 5px;
    border: none;
  }
  .pg-admissionlist__ticket_list__button__unadmission {
    background-color: blue;
    color: white;
    border-radius: 5px;
    border: none;
  }
  .pg-admissionlist__ticket_list__admitted_mark {
    font-size: 15px;
    color: red;
  }
  .pg-admissionlist__ticket_list__list_title {
    font-weight: bold;
    font-size: 15px;
  }
  .table-striped>tbody>tr:nth-of-type(even) {
    background-color: white;
  }

  .pg-admissionlist__ticket_list__label__no-g {
    width: 0%;
  }

  .pg-admissionlist__ticket_list__label__admisiion_status-g {
    width: 5%;
  }

  .pg-admissionlist__ticket_list__label__admisiion_operation-g {
    width: 4%;
  }

  .pg-admissionlist__ticket_list__label__volume-g {
    width: 0%;
  }

  .pg-admissionlist__ticket_list__label__introducer-g {
    width: 9%;
  }

  .pg-admissionlist__ticket_list__label__first_admission-g {
    width: 13%;
  }

</style>
